import { useMemo } from "react";
import { useStore } from "ra-core";

import type {
  DealStage,
  DealPipeline,
  LabeledValue,
  NoteStatus,
} from "../types";
import { defaultConfiguration } from "./defaultConfiguration";

export const getConfigurationStoreKey = (): string => {
  if (typeof window !== "undefined" && window.localStorage) {
    const activeCrmId = localStorage.getItem("dotus_active_crm_id");
    if (activeCrmId) {
      return `app.configuration.${activeCrmId}`;
    }
  }
  return "app.configuration.default";
};

export interface ConfigurationContextValue {
  companySectors: LabeledValue[];
  currency: string;
  dealCategories: LabeledValue[];
  dealPipelineStatuses: string[];
  dealStages: DealStage[];
  dealPipelines?: DealPipeline[];
  currentPipelineId?: string;
  noteStatuses: NoteStatus[];
  taskTypes: LabeledValue[];
  title: string;
  darkModeLogo: string;
  lightModeLogo: string;
  leadSources?: LabeledValue[];
  leadTemperatures?: LabeledValue[];
  contactCustomFields?: any[];
  companyCustomFields?: any[];
  dealCustomFields?: any[];
  taskCustomFields?: any[];
}

export const useConfigurationContext = () => {
  const storeKey = getConfigurationStoreKey();
  const [config] = useStore<ConfigurationContextValue>(
    storeKey,
    defaultConfiguration,
  );
  // Merge with defaults so that missing fields in stored config
  // fall back to default values (e.g. when new settings are added)
  return useMemo(() => ({ ...defaultConfiguration, ...config }), [config]);
};

export const useConfigurationUpdater = () => {
  const storeKey = getConfigurationStoreKey();
  const [, setConfig] = useStore<ConfigurationContextValue>(storeKey);
  return setConfig;
};
